import Client from "@/repositories/Client/AxiosClient.js"

const resource = `/api/kelin-meters/kelin-customer`

export default {
  list() {
    return Client.get(`${resource}`)
  },
  sync() {
    return Client.get(`${resource}/sync`)
  },
  get(customerId) {
    return Client.get(`${resource}/${customerId}`)
  },
  syncCheck() {
    return Client.get(`${resource}/sync-check`)
  },

  update(customer) {
    return Client.put(`${resource}/${customer.id}`, customer)
  },
}
